/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svcat_AutomationInputs */

const en_svcat_automation = /** @type {(inputs: Svcat_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation`)
};

const ar_svcat_automation = /** @type {(inputs: Svcat_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأتمتة`)
};

const bn_svcat_automation = /** @type {(inputs: Svcat_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অটোমেশন`)
};

const de_svcat_automation = /** @type {(inputs: Svcat_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisierung`)
};

const es_svcat_automation = /** @type {(inputs: Svcat_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatización`)
};

const fr_svcat_automation = /** @type {(inputs: Svcat_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisation`)
};

const pt_svcat_automation = /** @type {(inputs: Svcat_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automação`)
};

const zh_svcat_automation = /** @type {(inputs: Svcat_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动化`)
};

const tr_svcat_automation = /** @type {(inputs: Svcat_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomasyon`)
};

const ru_svcat_automation = /** @type {(inputs: Svcat_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматизация`)
};

const pl_svcat_automation = /** @type {(inputs: Svcat_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatyzacja`)
};

/**
* | output |
* | --- |
* | "Automation" |
*
* @param {Svcat_AutomationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svcat_automation = /** @type {((inputs?: Svcat_AutomationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svcat_AutomationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svcat_automation(inputs)
	if (locale === "bn") return bn_svcat_automation(inputs)
	if (locale === "de") return de_svcat_automation(inputs)
	if (locale === "es") return es_svcat_automation(inputs)
	if (locale === "fr") return fr_svcat_automation(inputs)
	if (locale === "pt") return pt_svcat_automation(inputs)
	if (locale === "zh") return zh_svcat_automation(inputs)
	if (locale === "tr") return tr_svcat_automation(inputs)
	if (locale === "ru") return ru_svcat_automation(inputs)
	if (locale === "pl") return pl_svcat_automation(inputs)
	return en_svcat_automation(inputs)
});